import { render } from "./CTAReadyOrderModule.vue?vue&type=template&id=416b2667&scoped=true"
import script from "./CTAReadyOrderModule.vue?vue&type=script&lang=js"
export * from "./CTAReadyOrderModule.vue?vue&type=script&lang=js"

import "./CTAReadyOrderModule.vue?vue&type=style&index=0&id=416b2667&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416b2667"]])

export default __exports__